import Vue from 'vue'
import VueRouter from 'vue-router'

import App from './App.vue'
import vuetify from './plugins/vuetify';

//inportin components
import Header from './components/Header.vue';
import Logon from './components/Logon.vue';
import MyGroups from './components/MyGroups.vue';
import Dashboard from './components/Dashboard.vue';
import Drawer from './components/Drawer.vue';
import TopCards from './components/TopCards.vue';
import NewCircleDialog from './components/NewCircleDialog.vue';
import Members from './components/tables/Members.vue';
import Tasks from './components/tables/Tasks.vue';
import BottomNav from './components/BottomNav.vue';

// Import component Members
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'

import VueSweetalert2 from 'vue-sweetalert2'; 
 
const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}

Vue.use(VueSweetalert2, options)

Vue.component('loader', Loading);
Vue.component('dashboard', Dashboard);
Vue.component('app-header', Header);
Vue.component('app-drawer', Drawer);
Vue.component('top-cards', TopCards);
Vue.component('new-circle-dialog', NewCircleDialog);
Vue.component('members', Members);
Vue.component('tasks', Tasks);
Vue.component('bottom-nav', BottomNav);


Vue.use(VueRouter)


const routes = [
  {path:'/', component:Logon},
  {path:'/logon', component:Logon},
  {path:'/mygroups', component:MyGroups},
  {path:'/dashboard', component:Dashboard},
  {path:'/drawer', component:Drawer}
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

Vue.config.productionTip = false
new Vue({
  vuetify,
  Header,
  router,
  render: h => h(App)
}).$mount('#app')
